import { PropsWithChildren } from 'react';

import { cn } from '../../lib/utils/classname';

interface Props extends PropsWithChildren {
  variant?: 'light' | 'dark';
}

const Tag: React.FC<Props> = ({ variant = 'dark', children }) => {
  return (
    <div
      className={cn('inline-flex px-2 py-1', {
        'bg-brand-primary text-white': variant === 'dark',
        'bg-brand-tertiary text-brand-primary': variant === 'light',
      })}
    >
      {children}
    </div>
  );
};

export default Tag;
